/**
 * @author German Rosario from YSW.
 */

 class YSWProductCard {
    constructor() {
        if (YSWProductCard.instance) {
            throw new Error('New instance cannot be created');
        }

        YSWProductCard.instance = this;
        this.init();
        this.runCount = 0;
    }

    init() {
        document.addEventListener('DOMContentLoaded', () => {
            this.run();
        });
    }

    run() {
        const swatchNodeList =
            this.runCount < 1
                ? document.querySelectorAll('.card__colors button:not(:first-child)')
                : document.querySelectorAll('.card__colors button');
        const swatches = Array.from(swatchNodeList);
        swatches.forEach((swatch) => this.onSwatch(swatch));
        this.runCount += 1;
    }

    /**
     * @param {Node} swatch Dom Element that handle the events to change the card's image.
     */
    onSwatch(swatch) {
        swatch.addEventListener('mouseenter', () => this.swatchHandler(swatch));
        swatch.addEventListener('mouseleave', () => {
            const defaultSwatch = swatch.parentElement.firstElementChild;
            this.swatchHandler(defaultSwatch);
        });
    }

    swatchHandler(swatch) {
        const colorOption = swatch.dataset.color;
        const card = swatch.closest('.card--ysw');

        if (card) {
            const mediaWrapper = card.querySelector('.media');
            this.changeImageFromSwatch(colorOption, mediaWrapper);
        }
    }

    changeImageFromSwatch(colorOption, mediaWrapper) {
        const images = Array.from(mediaWrapper.children);

        images.forEach((image) => {
            const options = image.dataset.colorOption.split(',');
            image.classList.remove('is-active');

            if (options.includes(colorOption)) image.classList.add('is-active');
        });
    }
}

window.ysw.productCard = new YSWProductCard();
